import React from 'react';
import { View } from 'react-native';
import { useQuery } from '@apollo/client';
import styled from 'styled-components/native';

import { Title } from 'app/src/styles';

import Customer from './Customer';
import { SHOPIFY_MERGE_SUGGESTIONS } from './queries';

const Suggestion = styled(View)`
  border-top-width: 2px;
  border-top-style: solid;
  border-top-color: #000000;
  margin-top: 20px;
`;

const Merge = () => {
  const { data } = useQuery(SHOPIFY_MERGE_SUGGESTIONS);

  if (!data) { return null; }

  return (
    <View>
      {data.shopifyMergeSuggestions.map(({ term, customers }) => (
        <Suggestion key={term}>
          <Title>{term}</Title>
          <View style={{ flexDirection: 'row' }}>
            {customers.map(customer => (
              <Customer key={customer.id} customer={customer} />
            ))}
          </View>
        </Suggestion>
      ))}
    </View>
  );
};

export default Merge;
